$(document).on('turbolinks:load', function () {
  const INTERACTIVE_ELEMENTS = ['BUTTON', 'LABEL', 'INPUT', 'TEXTAREA', 'SELECT', 'A'];
  
  function showUpgradeModal(feature) {
    fetch(`/dashboard/upgrade_required?feature=${feature}`, {
      method: 'GET'
    })
    .then(response => response.text())
    .then(script => eval(script))
    .catch(error => console.error('Error showing upgrade modal:', error));
  }

  // Check URL params for show_upgrade_modal
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('show_upgrade_modal')) {
    const feature = urlParams.get('show_upgrade_modal');
    showUpgradeModal(feature);
  }

  // Handle clicks on elements requiring upgrade
  $(document).on('click', '[data-upgrade-required], [data-upgrade-required-cont] *', function (e) {
    const targetTag = e.target.tagName.toUpperCase();
    const isInteractiveElement = INTERACTIVE_ELEMENTS.includes(targetTag);
    const hasUpgradeRequired = $(this).attr('data-upgrade-required') !== undefined;

    if (isInteractiveElement || hasUpgradeRequired) {
      e.preventDefault();

      const feature = $(this).closest('[data-upgrade-required]').data('feature') || 
                     $(this).closest('[data-upgrade-required-cont]').data('feature');

      showUpgradeModal(feature);
    }
  });
});
